module.exports = __webpack_public_path__ + "static/media/co15.45c37888.png";